import {createApp} from 'vue';
require('./bootstrap');

import App from './App.vue';
import axios from 'axios';
import router from './router';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const app = createApp(App);
app.use(VueSweetalert2);
app.config.globalProperties.$axios = axios;
app.use(router);
app.mount('#app');
